export default {
  title: 'Tilføj partner',
  mode: {
    single: 'Enkelt partner',
    bulk: 'Masseimport (CSV)',
  },
  buttons: {
    send_invite: 'Send invitation',
  },
  bulk: {
    form: {
      file: {
        label: 'Partnerliste (CSV)',
        hint: 'Én partner pr. række. Obligatoriske kolonner: Email, Company country og Registered company name eller Company name. Brand name er valgfrit og bliver til visningsnavnet for forbrugerne. Alle rækker valideres, før noget oprettes.',
      },
    },
    buttons: {
      select_file: 'Vælg CSV-fil',
      download_template: 'Download importskabelon',
      import: 'Importér partnere',
    },
    columns: {
      legal_name: 'Registered company name / Company name',
      display_name: 'Brand name',
      admin_email: 'Email',
      company_country: 'Company country',
    },
    errors: {
      title: 'Filen kunne ikke importeres.',
      nothing_imported: 'Ingen partner blev oprettet. Ret rækkerne ovenfor, og upload filen igen.',
      columns: {
        row: 'Række',
        column: 'Kolonne',
        error: 'Fejl',
      },
    },
    toasts: {
      queued_one:
        '{{count}} partner i kø – invitationer sendes, efterhånden som hver enkelt oprettes. Du får en samlet e-mail, når importen er færdig.',
      queued_other:
        '{{count}} partnere i kø – invitationer sendes, efterhånden som hver enkelt oprettes. Du får en samlet e-mail, når importen er færdig.',
    },
    footnote:
      'Partnere oprettes én ad gangen i baggrunden med samme opsætning som en enkelt partner: invitations-e-mail, dashboard-subdomæne og standardshopdomæne. Landet bestemmer valuta og tidszone; en delstat kan angives senere fra partnerprofilen. Betalingsbehandling konfigureres bagefter under hver partners fane Betalinger.',
  },
  form: {
    name: {
      label: 'Partnernavn',
    },
    admin_email: {
      label: 'Admin-e-mail (modtager af invitation)',
      hint: 'Vi sender en invitation på e-mail, så de kan oprette deres konto.',
    },
    display_name: {
      label: 'Visningsnavn for forbrugere',
      hint: 'Etiketten „Powered by ___“, som vises til kunderne. Bruger partnernavnet, hvis feltet er tomt.',
    },
    region: {
      label: 'Land',
      placeholder: 'Vælg et land',
      hint: 'Bestemmer partnerens valuta, tidszone og invitationssprog.',
      summary: 'Valuta {{currency}} · {{timezone}} · Invitationssprog {{language}}',
      default_root: 'Shopdomæne: nye brands vises på {{host}}',
    },
    sub_region: {
      label: 'Delstat',
      placeholder: 'Hele landet',
      hint: 'Valgfrit – lad feltet stå tomt for at gælde for hele landet.',
    },
    language: {
      label: 'Invitationssprog',
      placeholder: '{{language}} (standard)',
      hint: 'Valgfrit – bruger som standard landets primære sprog.',
    },
  },
  footnote: 'Branding- og indtjeningsindstillinger kan konfigureres, når partneren har accepteret sin invitation.',
  toasts: {
    created: 'Partner oprettet – invitations-e-mailen er på vej.',
  },
};
